import Logo from '@/components/Branding/Logo';
import {JwtContext, signOut} from '@/providers/JWTProvider';
import LogoutIcon from '@mui/icons-material/Logout';
import {Box, Button, Container} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import type * as React from 'react';
import {useContext} from 'react';
import {Outlet} from 'react-router-dom';

const Layout = (): React.ReactElement => {
    const user = useContext(JwtContext);

    return (
        <>
            <AppBar
                position='static'
                sx={{
                    backgroundColor: '#fff',
                    height: '110px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                }}
            >
                <Toolbar sx={{width: '100%'}}>
                    <Container
                        maxWidth='lg'
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'flex-end',
                        }}
                    >
                        <Box sx={{width: '20%'}}>
                            <Logo />
                        </Box>
                        <Typography variant='h6' sx={{color: 'black', pb: 1}}>
                            Glenbrook Student Activities
                        </Typography>
                        <Box sx={{width: '20%', display: 'flex', justifyContent: 'flex-end'}}>
                            {user !== null && (
                                <Button
                                    onClick={() => {
                                        signOut();
                                        window.location.reload();
                                        return;
                                    }}
                                    startIcon={<LogoutIcon sx={{ml: 2}} />}
                                    component='label'
                                    sx={{
                                        flexDirection: 'column',
                                        gap: 1,
                                        borderRadius: '4px',
                                        '&:hover': {
                                            backgroundColor: '#eee',
                                            color: '#3c52b2',
                                        },
                                        color: '#000',
                                    }}
                                >
                                    Sign-Out
                                </Button>
                            )}
                        </Box>
                    </Container>
                </Toolbar>
            </AppBar>
            <main>
                <Outlet />
            </main>
        </>
    );
};

export default Layout;
